<template>
  <div class="poi-list">
    <!-- aria-hidden because the content is duplicated for accessible label on the widget -->
    <h2 class="poi-list__heading" aria-hidden="true">
      {{ $t('web.widgets.localbusinesses.title') }}
    </h2>
    <template v-for="(poi, index) in items">
      <EDivider
        v-if="index !== 0"
        :key="'div'+poi.id"
        aria-hidden="true"
      />
      <EPoi
        :key="'poi'+poi.id"
        v-bind="poi"
        class="poi-list__item"
        data-test-id="poi"
        @click="$emit('poi-click')"
      />
    </template>
    <ELinkBubble
      class="poi-list__link"
      :href="url"
      :target="linkTarget"
      color="result"
      size="m"
      data-test-id="local-businesses-link"
      @click="$emit('link-click')"
    >
      <EIcon
        class="poi-list__link-icon"
        icon="source-tripadvisor"
        icon-size="m"
      />
      {{ $t('web.widgets.localbusinesses.cta') }}
    </ELinkBubble>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import EIcon from '~~/common/vue/components/icon';
import ELinkBubble from '~~/common/vue/components/link-bubble';
import EPoi from './poi';
import EDivider from '~~/common/vue/components/divider';

export default {
  name: 'EPoiList',
  components: {
    EIcon,
    ELinkBubble,
    EPoi,
    EDivider,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    url: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['linkTarget']),
  },
};
</script>
<style lang="scss" scoped>
.poi-list {
  counter-reset: poi-index;
}

.poi-list__item {
  margin: $space-1s #{-$space-1s};
}

.poi-list__heading {
  font-size: $font-m;
  font-weight: $font-weight-m;
  line-height: $line-height-m;
  margin: 0;
}

.poi-list__link {
  display: inline-flex;

  .icon {
    margin-right: $space-2s;
  }
}

.poi-list__link-icon {
  color: var(--color-button-content-secondary);
}
</style>
